module.exports = __webpack_public_path__ + "img/bu-head-passing-percentage.c54171e4.svg";